import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { passwordRequest, passwordResetRequest } from '../actions';
import Expired from '../components/pages/Expired';
import v3Expired from '../v3components/pages/Expired';
import ChangePassword from '../components/pages/ChangePassword';
import v3ChangePassword from '../v3components/pages/ChangePassword';
import ResetPassword from '../components/pages/ResetPassword';
import v3ResetPassword from '../v3components/pages/ResetPassword';

const getEnableV3Ui = () => {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return false;
    const raw = window.localStorage.getItem('EnableV3Ui');
    if (raw === null) return false;
    if (raw === 'true' || raw === '1') return true;
    if (raw === 'false' || raw === '0') return false;
    try { return JSON.parse(raw) === true; } catch (e) { return false; }
  } catch (e) {
    return false;
  }
};

const enableV3Ui = getEnableV3Ui();

const ChangePasswordComponent = enableV3Ui ? v3ChangePassword : ChangePassword;
const ResetPasswordComponent = enableV3Ui ? v3ResetPassword : ResetPassword;
const ExpiredComponent = enableV3Ui ? v3Expired : Expired;

class LoginContainer extends Component {
  render() {
    const {
      passwordRequest,
      passwordResetRequest,
      error,
      currentlySending,
      loading,
      location,
      match,
    } = this.props;

    if (location.pathname === '/ui/login/expired') {
      return (
        <ExpiredComponent
          passwordRequest={passwordRequest}
          error={error}
          currentlySending={currentlySending}
          loading={loading}
        />
      );
    } else if (location.pathname === '/ui/login/change-password') {
      return (
        <ChangePasswordComponent
          passwordRequest={passwordRequest}
          error={error}
          currentlySending={currentlySending}
          loading={loading}
        />
      );
    } else if (/\/ui\/login\/reset-password/i.test(location.pathname)) {
      return (
        <ResetPasswordComponent
          username={match.params.username}
          passwordResetRequest={passwordResetRequest}
          error={error}
          currentlySending={currentlySending}
          loading={loading}
        />
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = state => {
  return {
    error: state.requests.error,
    currentlySending: state.requests.currentlySending,
    loading: state.requests.loading,
    helperText: state.loginHelpText,
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      passwordRequest: passwordRequest,
      passwordResetRequest: passwordResetRequest,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer);
